import { render, staticRenderFns } from "./LogoIaqfaz.vue?vue&type=template&id=3aa3f1b0&scoped=true&"
import script from "./LogoIaqfaz.vue?vue&type=script&lang=js&"
export * from "./LogoIaqfaz.vue?vue&type=script&lang=js&"
import style0 from "./LogoIaqfaz.vue?vue&type=style&index=0&id=3aa3f1b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa3f1b0",
  null
  
)

export default component.exports